export default {
  "id": "icon-search",
  "width": 26.1,
  "height": 26.1,
  "viewBox": "0 0 26.1 26.1",
  "url": "sprites/app-icons-sprite.svg#icon-search-usage"
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/icons/icon-search.svg-sprite
// module id = yub8
// module chunks = 0